<script setup lang="ts">

import { onMounted } from "vue";
import { useViewModelInstance } from "@app/MyGarage";
import { useBackButton } from "@app/Components/Utilities";

import CarbucksProtect from "./Features/CarbucksProtect.vue";

const model = await useViewModelInstance();

onMounted( () =>
{
    useBackButton();
} );

</script>

<template>

    <div class="px-4 2xl:px-6 h-full overflow-y-auto pt-4 2xl:pt-6 pb-12">
        <CarbucksProtect v-model="model.carePlan.carbucksProtect" />
    </div>

</template>